module.exports = __webpack_public_path__ + "static/media/gad-circle.ac1a43f1.svg";